import { LegalDocument } from "../data/legal";
import { IconX } from "./Icons";
import { useLanguage } from "../context/LanguageContext";
import { uiText } from "../i18n/ui";

interface LegalModalProps {
  doc: LegalDocument;
  onClose: () => void;
}

export default function LegalModal({ doc, onClose }: LegalModalProps) {
  const { lang } = useLanguage();
  const t = uiText[lang].legal;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-primary/80 backdrop-blur-sm"
        onClick={onClose}
        aria-hidden="true"
      />

      <div className="relative w-full max-w-2xl bg-white rounded-2xl shadow-2xl p-6 sm:p-8 max-h-[85vh] overflow-y-auto">
        <button
          onClick={onClose}
          aria-label={t.close}
          className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-lg text-muted hover:bg-light hover:text-primary transition-colors"
        >
          <IconX size={20} />
        </button>

        <h1 className="text-xl sm:text-2xl font-bold text-primary pr-10">{doc.title}</h1>
        <p className="mt-1 text-sm text-muted">{t.lastUpdated} {doc.updatedAt}</p>

        <div className="mt-6 space-y-6">
          {doc.sections.map((section) => (
            <section key={section.heading}>
              <h2 className="text-base font-semibold text-primary">{section.heading}</h2>
              <div className="mt-2 space-y-3">
                {section.body.map((paragraph, i) => (
                  <p key={i} className="text-muted text-sm leading-relaxed">
                    {paragraph}
                  </p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
